import { SVGProps } from "react"

const Burger2Icon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 7H20.5"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.5 12H20.5"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.5 17H20.5"
        stroke={props.color || "#0E2846"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
export default Burger2Icon
